import { createSlice } from '@reduxjs/toolkit';
import { signIn, checkAuth, logout } from '../thunks/auth';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    isAuthenticating: false,
    userData: null
  },

  reducers: {},

  extraReducers: {
    [signIn.pending]: (state, action) => {
      state.isAuthenticating = true;
    },
    [signIn.fulfilled]: (state, action) => {
      state.userData = action.payload;
      state.isAuthenticating = false;
    },
    [signIn.rejected]: (state, action) => {
      state.isAuthenticating = false;
    },

    [checkAuth.pending]: (state, action) => {
      state.isAuthenticating = true;
    },
    [checkAuth.fulfilled]: (state, action) => {
      state.userData = action.payload;
      state.isAuthenticating = false;
    },
    [checkAuth.rejected]: (state, action) => {
      state.isAuthenticating = false;
    },

    [logout.fulfilled]: (state, action) => {
      state.userData = null;
    }
  }
});

export default userSlice.reducer;
